<template>
  <v-container fluid class="pa-0">
    <toolbar
      ref="toolbar"
      :items="datatableItems"
      @search="search"
      @adv-search="advancedSearch"
      @clear-search="clearSearch"
    />
    <datatable
      :search="searchObject"
      @items="getDatatableItems"
      @details="openDetailsDialog"
      @images="openImagesCarousel"
      @price="openPriceDialog"
      @rr-price="openRRPriceDialog"
      @buyer-details="showBuyerDetails"
      @qr="openQrDialog"
      @actions="openActionsDialog"
      @show-notes="openNotesDialog"
      @share="openShareDialog"
      @view-car="openCarDialog"
      @view-part="openViewPartDialog"
    />
    <qr-dialog ref="qrDialog" />
    <img-carousel ref="imgCarousel" />
    <buyer-details ref="buyerDetails" hide-contact />
    <price-dialog ref="priceDialog" />
    <rr-price-dialog ref="rrPriceDialog" />
    <actions-dialog ref="actionsDialog" @action-completed="getParts" />
    <notes-dialog ref="notesDialog" />
    <share-dialog ref="shareDialog" />
    <details-dialog ref="detailsDialog" />
    <car-dialog ref="carDialog" />
    <view-part ref="partDialog" @open-img-dialog="openImageDialog" />
    <img-dialog ref="imgDialog" />
  </v-container>
</template>

<script>
import Datatable from "@/components/ModuliRr/Orders/datatable.vue";
import Toolbar from "@/components/ModuliRr/Orders/toolbar.vue";
import ActionsDialog from "@/components/OrderedParts/actionsDialog.vue";
import ShareDialog from "@/components/OrderedParts/shareDialog.vue";
import RRPriceIncluded from "@/components/OrderedParts/priceDialog.vue";
import PartDetails from "@/components/OrderedParts/PartDetails.vue";

import BuyerDetails from "@/components/buyerDetails.vue";
import PriceDialog from "@/components/priceDialog.vue";
import DetailsDialog from "@/components/detailsDialog.vue";
import ImgCarousel from "@/components/imgCarousel.vue";
import QrDialog from "@/components/qrDialog.vue";
import NotesDialog from "@/components/notesDialog.vue";
import CarDialog from "@/components/carDialog.vue";
import ImgDialog from "@/components/imgDialog.vue";

export default {
  name: "ModuliRrOrders",
  components: {
    datatable: Datatable,
    toolbar: Toolbar,
    "buyer-details": BuyerDetails,
    "details-dialog": DetailsDialog,
    "actions-dialog": ActionsDialog,
    "price-dialog": PriceDialog,
    "img-carousel": ImgCarousel,
    "qr-dialog": QrDialog,
    "notes-dialog": NotesDialog,
    "share-dialog": ShareDialog,
    "rr-price-dialog": RRPriceIncluded,
    "car-dialog": CarDialog,
    "view-part": PartDetails,
    "img-dialog": ImgDialog,
  },
  data: () => ({
    searchObject: {
      type: null,
      data: {},
    },
    datatableItems: [],
  }),
  mounted() {
    const { id } = this.$route.query;

    if (id) {
      const { toolbar } = this.$refs;
      toolbar.setId(id);
      toolbar.searchMethod();
    }
  },
  methods: {
    getParts() {
      if (this.searchObject.type === null) {
        this.clearSearch();
      } else if (this.searchObject.type === "regularSearch") {
        this.search(this.searchObject.data);
      } else if (this.searchObject.type === "advancedSearch") {
        this.advancedSearch(this.searchObject.data);
      }
    },
    search(data) {
      this.searchObject = {
        type: "regularSearch",
        data,
      };
    },
    advancedSearch(data) {
      this.searchObject = {
        type: "advancedSearch",
        data,
      };
    },
    clearSearch() {
      this.searchObject = {
        type: null,
        data: {},
      };
    },
    getDatatableItems(data) {
      this.datatableItems = data;
    },
    openDetailsDialog(data) {
      this.$refs.detailsDialog.open(data);
    },
    openImagesCarousel(data) {
      this.$refs.imgCarousel.open(data);
    },
    openPriceDialog(data) {
      this.$refs.priceDialog.open(data);
    },
    showBuyerDetails(data) {
      this.$refs.buyerDetails.showBuyerDetails(data);
    },
    openQrDialog(data) {
      this.$refs.qrDialog.open(data);
    },
    openActionsDialog(data) {
      this.$refs.actionsDialog.open(data);
    },
    openNotesDialog(notes) {
      this.$refs.notesDialog.open(notes);
    },
    openShareDialog(data) {
      this.$refs.shareDialog.open([data]);
    },
    openRRPriceDialog(data) {
      this.$refs.rrPriceDialog.open(data);
    },
    openCarDialog(data) {
      this.$refs.carDialog.open(data);
    },
    openViewPartDialog(data) {
      this.$refs.partDialog.open(data);
    },
    openImageDialog(image) {
      this.$refs.imgDialog.open(image);
    },
  },
};
</script>
